export const PERMISSION = {
  CAMPAIGNMANAGEMENT_WRITE: "Campaigns.Write",
  USERMANAGEMENT_READ: "UserManagement.Read",
  ACCESSMANAGEMENT_READ: "AccessManagement.Read",
  BARMANAGEMENT_READ: "BarManagement.Read",
  CAMPAIGNMANAGEMENT_READ: "Campaigns.Read",
  COINSMANAGEMENT_READ: "Coins.Read",
  PRODUCTSMANAGEMENT_READ: "Products.Read",
  CONSUMPTIONMANAGEMENT_READ: "Consumption.Read",
  DEVICEMANAGEMENT_READ: "DeviceManagement.Read",
  FRAUDDETECTION_READ: "FraudDetection.Read",
  IMAGECLASSIFICATION_READ: "ImageClassification.Read",
  REWARDSMANAGEMENT_READ: "Rewards.Read",
  SBODISTRIBUTION_READ: "Distribution.Read",
  BRANDADMIN: "BrandAdmin",
  DASHBOARD: "Dashboard",
  CAMPAIGN_CREATE: "Campaigns.Create",
  CAMPAIGN_UPDATE: "Campaigns.Update",
  CAMPAIGN_DELETE: "Campaigns.Delete",
}
